import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from '../Button/Button';

export const Anexos = (props) => {
   
    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={'/informacion_general'}>Información general</Link>
                    </div>
                </div>
                <div className="subtitle">
                    <div className="subtitle--container">
                        <p className="ff-FuturaMedium">Anexos por modelo/plan</p>
                    </div>
                </div>
            </div>
            <div className="resultadosContainer--secondDiv">
                <div className="innerDiv">
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-mobi.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan mobi'  />
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-argo.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan argo' />
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-cronos.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan cronos' />
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-cronos-precision.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan cronos precision' />
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-strada.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan strada' />
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-toro.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan toro' />
                    <Button className="btn-info-general" pdf='/pdf/informacion-general/anexos/anexo-fiorino.pdf' img='/images/icons/download.svg' imgHover='/images/icons/download-vino.svg' text='Anexos plan fiorino' />
                </div>
            </div>
        </div>
    )
}
